import React, { useState, useRef, useEffect } from "react";
import {
  Button,
  Flex,
  FormControl,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  Spinner 
} from "@chakra-ui/react";
import { toast } from "react-toastify";

const ModalLoginPin = ({ isOpen, setIsOpen, onSubmit, submitLogin }: any) => {
  const [codes, setCodes] = useState<string[]>(["", "", "", "", "", ""]);
  const [loading, setLoading] = useState(false); 
  const inputsRef = useRef<HTMLInputElement[]>([]);
  const finalRef = useRef(null);

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;

    
    if (loading) {
      timer = setTimeout(() => {
        setLoading(false);
      }, 6000);
    }

    return () => {
      clearTimeout(timer);
    };
  }, [loading]);

  const handleChange = (index: number, value: string) => {
    const newCodes = [...codes];
    newCodes[index] = value.replace(/\D/g, "").slice(0, 1);
    setCodes(newCodes);

    if (value && index < codes.length - 1) {
      inputsRef.current[index + 1].focus();
    }
  };

  const handlePaste = (event: React.ClipboardEvent<HTMLInputElement>) => {
    const paste: any = event.clipboardData.getData('text').slice(0, 6); // Limita ao tamanho dos inputs
    const newCodes: any = [...paste].map((char) => char.replace(/\D/g, ""));
    setCodes(newCodes);

    newCodes.forEach((value: any, index: any) => {
      if (inputsRef.current[index]) {
        inputsRef.current[index].value = value;
      }
    });

    // Foca no próximo input após o último preenchido
    const nextIndex = paste.length < 6 ? paste.length : 5;
    if (inputsRef.current[nextIndex]) {
      inputsRef.current[nextIndex].focus();
    }
  };

  const handleKeyDown = (
    index: number,
    event: React.KeyboardEvent<HTMLInputElement>
  ) => {
    if (event.key === "Backspace" && !codes[index] && index > 0) {
      inputsRef.current[index - 1].focus();
    }
  };

  const handleSubmit = async () => {
    const code = codes.join("");
    try {
      setLoading(true); 
      await onSubmit(code); 
    } catch (error) {
      setLoading(false); 
      toast.error(`Erro ao enviar código de verificação para login: ${error}`);
    }
  };

  return (
    <>
      <Modal
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        size={"xl"}
      >
        <ModalOverlay backdropFilter="blur(10px)" />
        <ModalContent>
          <ModalHeader>
            <Flex w={"100%"} justifyContent={"center"} my={2}>
              <Text fontSize={"xl"} fontWeight={"bold"}>
                Digite seu código de verificação
              </Text>
            </Flex>
          </ModalHeader>
          <ModalBody>
            <Flex w={"100%"} justifyContent={"center"}>
              {codes.map((value, index) => (
                <Input
                  key={index}
                  ref={(el) => (inputsRef.current[index] = el as HTMLInputElement)}
                  type="text"
                  maxLength={1}
                  width="3rem"
                  textAlign="center"
                  value={value}
                  onChange={(e) => handleChange(index, e.target.value)}
                  onKeyDown={(e) => handleKeyDown(index, e)}
                  onPaste={handlePaste}
                  marginRight={2}
                />
              ))}
            </Flex>
          </ModalBody>

          <ModalFooter justifyContent={"space-evenly"}>
            <Button
              mt={4}
              onClick={handleSubmit}
              isLoading={loading} 
              loadingText="Enviando"
              disabled={loading} 
            >
              Confirmar código
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default ModalLoginPin;
